import { Chip, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useMemo,
    useState
} from "react";
import { connect } from "react-redux";
import { getAllActiveCategory } from "../../Slice/category.slice";
import {
    getActiveProduct,
    getActiveProductByCategory,
    getActiveProductByCategoryOptimized,
} from "../../Slice/product.slice";
import AutocompleteCompo from "../../components/Comman/AutoCompleteCompoForScheme";
import MultiSelectPopover from "../../components/Comman/PopoverCommon";
import { blueFadeColor, lightWhiteColor, lightWhiteFadeColor, violetShadeColor, white } from "../../config/ColorObj";
import { serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import "./Scheme.css";
import SchemeConditions from "./SchemeConditions";

/* ---------- STYLES (UNCHANGED) ---------- */
const CustomTextField = styled(TextField)(({ theme }) => ({
    "& .MuiOutlinedInput-root": {
        height: 42,
        borderRadius: "10px",
        transition: "border-color 0.2s ease",
        "& fieldset": { borderColor: theme.palette.grey[300] },
        "&:hover fieldset": { borderColor: blueFadeColor },
        "&.Mui-focused fieldset": {
            borderColor: blueFadeColor,
            borderWidth: 1.5,
        },
    },
    "& .MuiOutlinedInput-input": {
        padding: "8px 10px",
        fontSize: "14px",
    },
}));

/* ---------- DUMMY OPTIONS ---------- */
const regions = [
    { id: 0, name: "Flat Percentage (%)" },
    {
        id: 1,
        name: "Flat Amount",
    },
    {
        id: 2,
        name: "Percentage (%) Upto Given Amount",
    },
    {
        id: 3,
        name: "Bill-Wise Free Item",
    },
    { id: 4, name: "Percentage (%) Wise" },
    { id: 5, name: "Item-Wise Free Item" },
    {
        id: 6,
        name: "Free Item On Item",
    },
    {
        id: 7,
        name: "Free Item On Item",
    },
    { id: 8, name: "Flat Amount Off" },
    { id: 9, name: "Per Unit Value" },
    { id: 10, name: "Slab-Wise And Category-Wise Scheme Flat Discount – Qty Wise" },
    { id: 11, name: "Slab-Wise And Category-Wise Scheme Flat Discount – Value Wise" },
];
/* ---------- COMPONENT ---------- */
const SchemeLevelDetails = forwardRef((props, ref) => {
    const {
        offerDetails,
        getAllActiveCategory,
        getActiveProduct,
        getActiveProductByCategory,
        showLoador,
        showNotification,
        productList,
        onChange,
        getActiveProductByCategoryOptimized,
    } = props;
    const [form, setForm] = useState({
        levelType: null,
        applicableAmount: "",
        discountAmount: "",
        discountPercentage: "",
        product: null,
        productMultiple: [],
        categories: [],
        productQty: "",
    });
    const [isReverseCalculation, setIsReverseCalculation] = useState(0);
    const reverseCalculationOptions = [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
    ];

    const [categoryList, setCategoryList] = useState([]);
    const [productFromCatogoriesList, setProductFromCatogoriesList] = useState([]);
    const [schemeConditionsValidator, setSchemeConditionsValidator] = useState();
    const [schemeConditionsData, setSchemeConditionsData] = useState({});
    const categoryAnchorRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [activePopover, setActivePopover] = React.useState(null);


    const productOptions = useMemo(
        () =>
            Array.isArray(productList?.activeProduct)
                ? productList.activeProduct
                : [],
        [productList?.activeProduct]
    );

    const categoryOptions = useMemo(
        () =>
            Array.isArray(categoryList)
                ? categoryList
                : [],
        [categoryList]
    );

    const [errors, setErrors] = useState({});
    const [shake, setShake] = useState({});

    useEffect(() => {
        if (form?.levelType?.id == 10 || form?.levelType?.id == 11) {
            setForm(prev => ({
                ...prev,
                categories: [],
            }));
        }
    }, [form?.levelType?.id]);

    const emitChange = (nextForm, nextExtras) => {
        onChange?.({
            ...nextForm,
            ...nextExtras,
        });
    };

    /* ------------------ API WRAPPER ------------------ */
    const callApi = async (apiFn, payload) => {
        showLoador({ loador: true });
        const res = await apiFn(payload);
        showLoador({ loador: false });

        if (!res?.success) {
            showNotification({ msg: serverMsg, severity: "error" });
        }
    };

    /* ---------- CHANGE HANDLER ---------- */
    const handleChange = async (key, value) => {
        setForm(prev => ({ ...prev, [key]: value }));
        setErrors(prev => ({ ...prev, [key]: "" }));
        setShake(prev => ({ ...prev, [key]: false }));
        const nextForm = { ...form, [key]: value };
        emitChange(nextForm, {});


        // Only call API when SINGLE selection
        if (key === "product" && !Array.isArray(value) && value?.id) {
            const selected = productList.activeProduct.find(
                (item) => item.id === value.id
            );

            if (selected) {
                await callApi(getActiveProductByCategory, {
                    categoryId: selected.category,
                });
            }
        }

    };

    const handlePillChange = (key, value) => {
        const next = {
            [key]: value,
        };
        if (key === "isReverseCalculation") setIsReverseCalculation(value);

        emitChange(form, next);
    };


    /* ---------- VALIDATION ---------- */
    const validate = () => {
        let valid = true;
        const newErrors = {};
        const newShake = {};

        const isDiscountPercentageRequired =
            form.levelType?.id == 0 || form.levelType?.id == 2;

        const isDiscountAmountRequired =
            offerDetails?.offerLevel == 0 && form.levelType?.id == 1;

        const isMultipleProductRequired =
            form.levelType?.id == 7 ||
            form.levelType?.id == 8 ||
            form.levelType?.id == 9;

        const isProductRequired = offerDetails?.offerLevel === 1 && form.levelType?.id == 4 ||
            form.levelType?.id == 5;

        const isProductQtyRequired =
            offerDetails?.offerLevel == 1 &&
            (form.levelType?.id != 8 && form.levelType?.id != 9 &&
                form.levelType?.id != 10 && form.levelType?.id != 11);

        const isCategoryRequired = offerDetails?.offerLevel == 1 && (form.levelType?.id == 10 || form.levelType?.id == 11);

        const rules = {
            levelType: !form.levelType,

            applicableAmount: offerDetails?.offerLevel == 0 && !form.applicableAmount,

            discountAmount:
                isDiscountAmountRequired && !form.discountAmount,

            discountPercentage:
                isDiscountPercentageRequired && !form.discountPercentage,

            product:
                !isMultipleProductRequired && isProductRequired && !form.product,

            productMultiple:
                isMultipleProductRequired &&
                (!Array.isArray(form.productMultiple) ||
                    form.productMultiple.length == 0),

            categories:
                isCategoryRequired && (!Array.isArray(form.categories) ||
                    form.categories.length == 0),

            productQty:
                isProductQtyRequired && !form.productQty,
        };

        Object.keys(rules).forEach((key) => {
            if (rules[key]) {
                valid = false;

                newErrors[key] = `${key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())} is required`;

                newShake[key] = true;

                setTimeout(() => {
                    setShake((prev) => ({ ...prev, [key]: false }));
                }, 400);
            }
        });

        setErrors(newErrors);
        setShake(newShake);

        return {
            isValid: valid,
            data: form,
        };
    };

    /* ---------- EXPOSE TO PARENT ---------- */
    useImperativeHandle(ref, () => ({
        validate,
        schemeConditionsValidator,
        getData: () => ({
            ...form,
            productFromCatogoriesList,
        }),
        schemeConditionsDetails: () => ({
            schemeConditionsData
        }),
    }));

    /* ------------------ COMMON AUTOCOMPLETE ------------------ */
    const commonAutoProps = {
        size: "small",
        getOptionLabel: (o) => o?.name || "",
        isOptionEqualToValue: (o, v) => o?.id === v?.id,

        sx: {
            "& .MuiInputBase-input": {
                fontSize: "14px",
                fontFamily: "Poppins, Helvetica, Arial, sans-serif",
            },
        },

        componentsProps: {
            paper: {
                sx: {
                    fontSize: "14px",
                    fontFamily: "Poppins, Helvetica, Arial, sans-serif",
                },
            },
            popper: {
                sx: {
                    "& .MuiAutocomplete-option": {
                        fontSize: "14px",
                        fontFamily: "Poppins, Helvetica, Arial, sans-serif",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        margin: "2px 6px",

                        "&.Mui-selected": {
                            backgroundColor: "#4861df !important",
                            color: white,
                        },
                        "&.Mui-selected.Mui-focused": {
                            backgroundColor: "#4861df !important",
                        },
                        "&:hover": {
                            backgroundColor: lightWhiteFadeColor,
                        },
                    },
                },
            },
        },
    };

    useEffect(() => {
        if (!offerDetails) return;

        setForm((prev) => ({ ...prev, levelType: null }));

    }, [
        offerDetails?.stakeholderType,
        offerDetails?.offerType,
        offerDetails?.applicableOn,
        offerDetails?.calculatedBy,
        offerDetails?.offerLevel
    ]);

    useEffect(() => {
        const fetchData = async () => {

            showLoador({ loador: true });

            await getActiveProduct().then(({ success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            }
            );

            await getAllActiveCategory().then(({ response, success }) => {
                if (success) {
                    setCategoryList(response);
                } else {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });
        };

        fetchData();
    }, []);

    const filteredRegions = useMemo(() => {
        if (offerDetails?.offerLevel === 1 && offerDetails?.offerType === 0) {
            // Item Level
            return regions.filter((r) => [4, 5, 7, 10, 11].includes(r.id));
        }

        if (offerDetails?.offerLevel === 0 && offerDetails?.offerType === 1) {
            // Item Level
            return regions.filter((r) => [1, 6].includes(r.id));
        }

        if (offerDetails?.offerLevel === 1 && offerDetails?.offerType === 1) {
            // Item Level
            return regions.filter((r) => [8, 9, 10, 11].includes(r.id));
        }
        return regions.filter((r) => [0, 1, 2, 3, 6].includes(r.id));

        // Bill Level (default)
    }, [
        offerDetails?.offerLevel,
        offerDetails?.offerType,
        regions
    ]);

    const renderExpandableTags = (type) => (value, getTagProps) => {
        const visible = value.slice(0, 4);
        const hiddenCount = value.length - visible.length;

        return (
            <>
                {visible.map((option, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.name}
                        size="small"
                    />
                ))}

                {hiddenCount > 0 && (
                    <Chip
                        label={`+${hiddenCount}`}
                        size="small"
                        onClick={() => {
                            setAnchorEl(categoryAnchorRef.current);
                            setActivePopover("categories");
                        }}
                        sx={{
                            backgroundColor: lightWhiteColor,
                            color: violetShadeColor,
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    />
                )}
            </>
        );
    };

    const handleCategoryChange = async (event, selectedCategories) => {
        // Update state
        setForm((prev) => ({
            ...prev,
            categories: selectedCategories,
        }));

        if (!selectedCategories || selectedCategories.length === 0) {
            setProductFromCatogoriesList([]);
            return;
        }

        // Extract category IDs
        const categoryIds = selectedCategories.map(cat => cat.id);

        if (categoryIds.length > 0) {

            let categoryIdsDataJson = {
                categoryIds: categoryIds
            }

            showLoador({ loador: true });
            await getActiveProductByCategoryOptimized({
                categoryIdData: categoryIdsDataJson
            }).then(({ response, success }) => {
                if (success) {
                    setProductFromCatogoriesList(response)
                } else {
                    showNotification({ msg: serverMsg, severity: "error" });

                }
            });
            showLoador({ loador: false });
        }
    };

    const multiProps = {
        multiple: true,
        disableCloseOnSelect: true,
    };


    return (
        <>
            <div className="card-scheme">
                <div className="card-title-scheme">🧩 Level Conditions</div>

                <div className="grid-scheme mt-16">
                    <div className={shake.levelType ? "shake-error" : ""}>
                        <label className="required-label">Level Wise Type</label>
                        <AutocompleteCompo
                            {...commonAutoProps}
                            options={filteredRegions}
                            value={form.levelType}
                            onChange={(e, v) => {
                                handleChange("levelType", v);
                            }}
                            renderInput={(p) => (
                                <CustomTextField
                                    {...p}
                                    placeholder="Select Level Wise Type"
                                    error={Boolean(errors.levelType)} //red border
                                    helperText={errors.levelType}
                                />
                            )}
                        />
                    </div>

                    {(offerDetails?.offerLevel == 0) && (
                        <div className={shake.applicableAmount ? "shake-error" : ""}>
                            <label className="required-label">Applicable Amount</label>
                            <input
                                className={`input-scheme ${errors.applicableAmount ? "error-input" : ""}`}
                                placeholder="Enter Applicable Amount"
                                value={form.applicableAmount}
                                onChange={(e) => handleChange("applicableAmount", e.target.value)}
                            />
                            {errors.applicableAmount && (
                                <span className="error">{errors.applicableAmount}</span>
                            )}
                        </div>
                    )}

                    {offerDetails?.offerLevel == 0 && form.levelType?.id === 1 && (
                        <div className={shake.discountAmount ? "shake-error" : ""}>
                            <label className="required-label">Discount Amount</label>
                            <input
                                className={`input-scheme ${errors.discountAmount ? "error-input" : ""}`}
                                placeholder="Enter Discount Amount"
                                value={form.discountAmount}
                                onChange={(e) => handleChange("discountAmount", e.target.value)}
                            />
                            {errors.discountAmount && (
                                <span className="error">{errors.discountAmount}</span>
                            )}
                        </div>
                    )}

                    {(form.levelType?.id === 0 ||
                        form.levelType?.id === 2) && (
                            <div className={shake.discountPercentage ? "shake-error" : ""}>
                                <label className="required-label">Discount Percentage (%)</label>
                                <input
                                    className={`input-scheme ${errors.discountPercentage ? "error-input" : ""}`}
                                    placeholder="Enter Discount Percentage (%)"
                                    value={form.discountPercentage}
                                    onChange={(e) =>
                                        handleChange("discountPercentage", e.target.value)
                                    }
                                />
                                {errors.discountPercentage && (
                                    <span className="error">{errors.discountPercentage}</span>
                                )}
                            </div>
                        )}

                    {offerDetails?.offerLevel === 1 &&
                        (
                            form.levelType?.id === 4 ||
                            form.levelType?.id === 5 ||
                            form.levelType?.id === 7 ||
                            form.levelType?.id === 8 ||
                            form.levelType?.id === 9
                        ) && (
                            <>
                                <div className={
                                    (form.levelType?.id === 7 ||
                                        form.levelType?.id === 8 ||
                                        form.levelType?.id === 9 ?
                                        shake.productMultiple : shake.product) ?
                                        "shake-error"
                                        : ""}>
                                    <label>Product</label>
                                    <AutocompleteCompo
                                        {...commonAutoProps}
                                        multiple={
                                            form.levelType?.id === 7 ||
                                            form.levelType?.id === 8 ||
                                            form.levelType?.id === 9
                                        }
                                        disableCloseOnSelect={
                                            form.levelType?.id === 7 ||
                                            form.levelType?.id === 8 ||
                                            form.levelType?.id === 9}
                                        options={productOptions}
                                        value={
                                            (form.levelType?.id === 7 ||
                                                form.levelType?.id === 8 ||
                                                form.levelType?.id === 9)
                                                ? form.productMultiple || []
                                                : form.product
                                        }
                                        onChange={(e, value) => {
                                            if (form.levelType?.id === 7 ||
                                                form.levelType?.id === 8 ||
                                                form.levelType?.id === 9
                                            ) {
                                                setForm((prev) => ({ ...prev, productMultiple: value }));
                                            } else {
                                                handleChange("product", value);
                                            }
                                        }}
                                        getOptionLabel={(option) => option?.productName || ""}
                                        renderTags={(value, getTagProps) => {
                                            const visible = value.slice(0, 2);
                                            const hiddenCount = value.length - visible.length;

                                            return (
                                                <>
                                                    {visible.map((option, index) => (
                                                        <Chip
                                                            {...getTagProps({ index })}
                                                            key={option.id}
                                                            label={option.productName}
                                                            size="small"
                                                        />
                                                    ))}

                                                    {hiddenCount > 0 && (
                                                        <Chip
                                                            label={`+${hiddenCount}`}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: lightWhiteFadeColor,
                                                                color: blueFadeColor,
                                                                cursor: "pointer",
                                                                fontWeight: 600,
                                                            }}
                                                            onMouseDown={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setPopoverAnchor(e.currentTarget);
                                                                setPopoverItems(value);
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            );
                                        }}

                                        renderInput={(params) => (
                                            <CustomTextField
                                                {...params}
                                                placeholder="Select Product"
                                                error={Boolean(errors.product)}
                                                helperText={errors.product}
                                            />
                                        )}
                                    />
                                </div>

                                {(form.levelType?.id != 8 && form.levelType?.id != 9 && form.levelType?.id != 10 && form.levelType?.id != 11) && (
                                    <div className={shake.productQty ? "shake-error" : ""}>
                                        <label>Product Quantity</label>
                                        <input
                                            className={`input-scheme ${errors.productQty ? "error-input" : ""}`}
                                            placeholder="Enter Product Quantity"
                                            value={form.productQty}
                                            onChange={(e) => handleChange("productQty", e.target.value)}
                                        />
                                        {errors.productQty && (
                                            <span className="error">{errors.productQty}</span>
                                        )}
                                    </div>
                                )}
                            </>
                        )}



                    {offerDetails?.offerLevel == 1 &&
                        (
                            (form.levelType?.id == 10 || form.levelType?.id == 11)
                        ) && (
                            <>
                                <div
                                    ref={categoryAnchorRef}
                                    className={shake.categories ? "shake-error" : ""}
                                >
                                    <label className="required-label">Category</label>

                                    <AutocompleteCompo
                                        {...commonAutoProps}
                                        {...multiProps}
                                        options={categoryOptions}
                                        value={form.categories}
                                        renderTags={renderExpandableTags("categories")}
                                        onChange={(e, v) => {
                                            handleCategoryChange("categories", v);
                                            setErrors((prev) => ({
                                                ...prev,
                                                categories: v ? "" : "Category is required",
                                            }));
                                        }}

                                        enableSelectActions
                                        onSelectAll={() => {
                                            handleCategoryChange("categories", categoryOptions);
                                            setErrors((prev) => ({
                                                ...prev,
                                                categories: "",
                                            }));
                                        }}
                                        onRemoveAll={() => {
                                            handleCategoryChange("categories", []);
                                            setErrors((prev) => ({
                                                ...prev,
                                                categories: "Category is required",
                                            }));
                                        }}
                                        placeholder="Select Category"
                                        error={errors.categories}
                                        helperText={errors.categories}
                                    />

                                    <MultiSelectPopover
                                        open={Boolean(anchorEl) && activePopover === "categories"}
                                        anchorEl={anchorEl}
                                        items={form.categories}
                                        onClose={() => {
                                            setAnchorEl(null);
                                            setActivePopover(null);
                                        }}
                                        onRemove={(item) => {
                                            setForm((prev) => {
                                                const updated = prev.categories.filter(
                                                    (cat) => cat.id !== item.id
                                                );

                                                if (updated.length === 0) {
                                                    setAnchorEl(null);
                                                    setActivePopover(null);
                                                }

                                                return {
                                                    ...prev,
                                                    categories: updated,
                                                };
                                            });
                                        }}
                                    />


                                </div>
                            </>
                        )}


                    {(form?.levelType?.id == 8 ||
                        form?.levelType?.id == 9 ||
                        form?.levelType?.id == 10 ||
                        form?.levelType?.id == 11
                    ) && (
                            <div>
                                <label>Is Reverse Calculation Applicable?</label>
                                <div className="pill-scheme-group">
                                    {reverseCalculationOptions.map((val) => (
                                        <div
                                            key={val.value}
                                            className={`pill-scheme  ${isReverseCalculation === val.value ? "active" : ""}`}
                                            onClick={() => handlePillChange("isReverseCalculation", val.value)}
                                        >
                                            {val.label}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                </div>
            </div >

            {(form?.levelType?.id == 8 ||
                form?.levelType?.id == 9 ||
                form?.levelType?.id == 10 ||
                form?.levelType?.id == 11
            ) &&
                <SchemeConditions
                    offerDetails={offerDetails}
                    offerLevelDetails={form}
                    productFromCatogoriesList={productFromCatogoriesList}
                    schemeConditonsValidations={setSchemeConditionsValidator}
                    schemeConditionsDetails={setSchemeConditionsData}
                />
            }
        </>
    );
});

const mapStateToProps = (state) => ({
    productList: state.product,
    stakeHolderTypeList: state.stockStakeHolderType,
});

const mapDispatchToProps = {
    getActiveProduct,
    getActiveProductByCategory,
    showLoador,
    showNotification,
    getAllActiveCategory,
    getActiveProductByCategoryOptimized,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(SchemeLevelDetails);